import Disclaimer from "../../../../contents/docs/self-host/_snippets/disclaimer.mdx";
import Sunset from "../../../../contents/docs/self-host/_snippets/sunset-disclaimer.mdx";
import * as React from 'react';
export default {
  Disclaimer,
  Sunset,
  React
};